module.exports = __webpack_public_path__ + "static/media/Solitary-Layout.29c14ee5.png";